<template :pageData="pageData">
	<div class="page-wrapper app-page">
		<div class="t-center">
			<div class="app-logo">
				<img src="../static/freelogo.png" alt="app">
			</div>
			<span class="app-title">
				macOS <span style="color: #05b65b">免费</span>优质 APP
			</span>
		</div>
		<div class="wrapper app-wrapper">
			<a class="app shadow" v-for="(app, index) in pageData.Freeapp" :key="index" target="_blank" :title="app.description" :href="app.link">
				<img class="app-icon" v-lazy="app.icon" :alt="app.name">
				<div class="app-name">{{ app.name }}</div>
				<p class="app-des">{{ app.description }}</p>
			</a>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Freeapp',
		props: ['pageData']
	}
</script>

<style src="../assets/style.css"></style>
